export default __webpack_public_path__ + "ee7a4858c033e05326c0897970bb3ad2.png";